<template>
  <div class="w-full h-full overflow-y-auto">
    <el-form
      class="w-1200px m-auto my-0"
      :model="form"
      :rules="formRule"
      ref="formRef"
    >
      <el-row>
        <el-col :span="12"
          ><el-form-item label="英文名称" prop="engName">
            <el-input
              v-model="form.engName"
              placeholder="Name model name"
              :disabled="form.id > -1||modelNameDisable"
              maxlength="100"
              show-word-limit
            /> </el-form-item
        ></el-col>
        <el-col :span="12">
          <div class="tips">
            <img src="@/assets/images/information.png" class="w-19px h-19px" />
            <span class="ml-10px text-default text-16px">一经创建不可修改</span>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12"
          ><el-form-item label="中文名称" prop="name">
            <el-input
              v-model="form.name"
              placeholder="为您的模型起个名字，最多100字"
              maxlength="100"
              show-word-limit
            /> </el-form-item
        ></el-col>
      </el-row>
      <el-row>
        <el-col :span="12"
          ><el-form-item label="发布者" prop="owner">
            <el-select v-model="form.owner" :disabled="form.id > -1">
              <el-option
                v-for="(item, index) in ownerOptions"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select> </el-form-item
        ></el-col>
        <el-col :span="12">
          <div class="tips">
            <img src="@/assets/images/information.png" class="w-19px h-19px" />
            <span class="ml-10px text-default text-16px">一经创建不可修改</span>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12"
          ><el-form-item label="开源协议" prop="protocol">
            <el-select v-model="form.protocol" placeholder="请选择开源协议">
              <el-option
                v-for="item in protocolOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select> </el-form-item
        ></el-col>
        <el-col :span="12"
          ><el-form-item label="支持模型类型" prop="modelType">
            <select-model-type v-model="form.modelType" /> </el-form-item
        ></el-col>
      </el-row>
      <el-row>
        <el-col :span="12"
          ><el-form-item label="应用场景" prop="applicationScenario">
            <wise-select v-model="form.applicationScenario" /> </el-form-item
        ></el-col>
        <el-col :span="12"
          ><el-form-item label="语言" prop="language">
            <wise-select
              v-model="form.language"
              placeholder="请选择语言"
              :options="$store.state.selectOptions.language"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12"
          ><el-form-item label="是否公开" prop="isOpen">
            <el-radio
              v-model="form.isOpen"
              v-for="item in $store.state.selectOptions.isOpen"
              :key="item.id"
              :label="item.id"
              >{{ item.name }}</el-radio
            >
          </el-form-item></el-col
        >
      </el-row>
      <el-form-item label="自定义标签">
        <tag
          :tags="form.customTag"
          @delete="deleteLabel"
          @confirm="addTagConfirm"
          ref="tag"
        />
      </el-form-item>
      <el-form-item label="数据集简介">
        <el-input
          v-model="form.modelProfile"
          type="textarea"
          placeholder="请填写简介，最多500字"
          :rows="3"
          maxlength="500"
          show-word-limit
        ></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import tag from '@/components/tag.vue'
import selectModelType from '@/components/select-model-type.vue'
import selectSupportFramework from '@/components/select-support-framework.vue'
import wiseSelect from '@/components/wise-select.vue'
import { getPublisher } from '@/utils/getSelectOptions'
import { valiEngName } from '@/utils/validate'

export default {
  components: { tag, selectModelType, selectSupportFramework, wiseSelect },
  model: {
    prop: 'form',
    event: 'setForm'
  },
  props: ['form'],
  data() {
    const engNameValidate = (rule, value, callback) => {
      const { status, message } = valiEngName(value)

      if (!status) {
        callback(message)
      } else {
        callback()
      }
    }

    return {
      modelNameDisable:false,
      formRule: {
        engName: [
          { required: true, validator: engNameValidate, trigger: 'blur' }
        ],
        name: [{ required: true, message: '请填写中文名称', trigger: 'blur' }],
        owner: [{ required: true, message: '请选择发布者', trigger: 'change' }],
        protocol: [
          { required: true, message: '请选择开源协议', trigger: 'change' }
        ],
        modelType: [
          { required: true, message: '请选择模型类型', trigger: 'change' }
        ],
        isOpen: [{ required: true, message: '请选择是否公开', trigger: 'change' }]
      }
    }
  },
  computed: {
    supportOptions() {
      return this.$store.state.selectOptions.isSupport
    },
    protocolOptions() {
      return this.$store.state.selectOptions.license
    },
    ownerOptions() {
      return this.$store.state.selectOptions.owner
    }
  },
  created() {
    getPublisher()
  },
  mounted() {},
  methods: {
    // 自定义添加标签确定事件
    addTagConfirm(value) {
      this.$api.project
        .addlabel({
          name: value
        })
        .then((res) => {
          if (res.message === 'Success') {
            this.form.customTag.push({
              name: value,
              id: res.data
            })
            this.$refs.tag.finishAdd()
          }
        })
        .finally(() => {
          this.$refs.tag.finishAdd()
        })
    },
    // 删除标签
    deleteLabel({ index }) {
      this.form.customTag.splice(index, 1)
    },
    setDisable(){
      this.modelNameDisable=true
    },
    setUnDisable(){
      this.modelNameDisable=false
    }
  }
}
</script>
<style lang="scss" scoped>

.tips {
  display: flex;
  align-items: center;
  margin-left: 20px;
  margin-top: 10px;
}

</style>
